import { Component, FunctionalComponent, h } from 'preact';
import { ILanguageSelectorProps } from '../sgwt-super-header.types';

interface IPropsDropdownItem {
  label: string;
  onClick: () => void;
}

const DropdownItem: FunctionalComponent<IPropsDropdownItem> = ({
  label,
  onClick
}: IPropsDropdownItem) => (
  <li role="presentation">
    <a onClick={onClick} role="menuitem" tabIndex={-1}>
      {label}
    </a>
  </li>
);

interface ILanguageSelectorState {
  isOpen: boolean;
}

export default class LanguageSelector extends Component<
  ILanguageSelectorProps,
  ILanguageSelectorState
> {
  private handler?: HTMLLIElement;

  constructor(props: ILanguageSelectorProps) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render(
    props: ILanguageSelectorProps,
    { isOpen }: ILanguageSelectorState
  ): JSX.Element | null {
    let allLanguages = props.availableLanguages!.split(',');
    if (allLanguages.length > 1) {
      return (
        <li
          className={`hidden-xs ${isOpen ? 'open ' : ''}dropdown`}
          ref={(handler: HTMLLIElement) => {
            this.handler = handler;
          }}
        >
          <a
            aria-expanded={isOpen}
            aria-haspopup="true"
            className="dropdown-toggle"
            id="sgwt-super-header-languages-dropdown"
            href="#"
            onClick={this.handleDropdownToggle}
            role="button"
          >
            {`${props.language.toUpperCase()} `}
            <span className="caret" />
          </a>
          <ul
            role="menu"
            className="dropdown-menu"
            aria-labelledby="sgwt-super-header-languages-dropdown"
          >
            {allLanguages.map(lang => (
              <DropdownItem
                label={lang.toUpperCase()}
                onClick={() => {
                  this.handleClick(lang);
                }}
              />
            ))}
          </ul>
        </li>
      );
    }
    if (props.hideCurrentLanguage) {
      return null;
    }
    return (
      <li className="hidden-xs" id="sgwt-super-header-current-language">
        {props.language.toUpperCase()}
      </li>
    );
  }

  private handleClick = (lang: string) => {
    this.props.onLanguageChanged(lang);
    this.handleClose();
  };

  private handleClose = (event?: Event) => {
    if (event) {
      event.preventDefault();
    }
    document.removeEventListener('click', this.handleOutsideClick, false);
    document.removeEventListener('touchend', this.handleOutsideClick, false);
    document.removeEventListener('keydown', this.handleKeydown, false);
    this.setState({ isOpen: false });
  };

  private handleDropdownToggle = (event: Event) => {
    if (event) {
      event.preventDefault();
    }
    const { isOpen } = this.state;
    if (isOpen) {
      this.handleClose();
    } else {
      document.addEventListener('click', this.handleOutsideClick, false);
      document.addEventListener('touchend', this.handleOutsideClick, false);
      document.addEventListener('keydown', this.handleKeydown, false);
      this.setState({ isOpen: true });
    }
  };

  private handleKeydown = (event: KeyboardEvent) => {
    const { isOpen } = this.state;
    if (isOpen && (event.key === 'Escape' || event.which === 27)) {
      this.handleClose();
    }
  };

  private handleOutsideClick = (event: Event) => {
    if (this.handler && !this.handler.contains(event.target as Node)) {
      this.handleClose();
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/LanguageSelector.tsx